import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AllCustomerOrderDeliveriesDataGrid } from "src/components/views/erp/sales/delivery/AllCustomerOrderDeliveriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/delivery/allCustomerOrderDeliveries")({
	staticData: { title: i18n.t("all_deliveries"), legacyViewKey: "allCustomerOrderDeliveriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AllCustomerOrderDeliveriesDataGrid />;
}
